'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuSlide = require('@viskan/deku-slide');

var _dekuSlide2 = _interopRequireDefault(_dekuSlide);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _togglerPresentation = require('../../utils/toggler-presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseNumber = function parseNumber(num, def) {
	return parseInt(num, 10) || def;
};

var render = function render(_ref) {
	var props = _ref.props;

	var iconNext = props.iconNext && props.type !== 'none' ? (0, _togglerPresentation.getPresentation)('Next', props) : '';
	var iconPrev = props.iconPrev && props.type !== 'none' ? (0, _togglerPresentation.getPresentation)('Prev', props) : '';

	var options = {
		roundLengths: props.roundLengths,
		simulateTouch: props.cmsLoaded
	};

	switch (props.breakpoint) {
		case 'xsm':
		case 'sm':
			options.centeredSlides = props.centeredSlidesMobile;
			options.slidesPerColumn = parseNumber(props.slidesPerColumnMobile, 1);
			options.slidesPerGroup = parseNumber(props.slidesPerGroupMobile, 1);
			options.slidesPerView = parseNumber(props.slidesPerViewMobile, 1);
			options.spaceBetween = parseNumber(props.spaceBetweenMobile, 0);
			break;
		case 'md':
			options.centeredSlides = props.centeredSlidesTablet;
			options.slidesPerColumn = parseNumber(props.slidesPerColumnTablet, 1);
			options.slidesPerGroup = parseNumber(props.slidesPerGroupTablet, 1);
			options.slidesPerView = parseNumber(props.slidesPerViewTablet, 1);
			options.spaceBetween = parseNumber(props.spaceBetweenTablet, 0);
			break;
		default:
			options.centeredSlides = props.centeredSlidesDesktop;
			options.slidesPerColumn = parseNumber(props.slidesPerColumnDesktop, 1);
			options.slidesPerGroup = parseNumber(props.slidesPerGroupDesktop, 1);
			options.slidesPerView = parseNumber(props.slidesPerViewDesktop, 1);
			options.spaceBetween = parseNumber(props.spaceBetweenDesktop, 0);
	}

	var settings = {
		arrows: props.arrows,
		iconNext: iconNext,
		iconPrev: iconPrev,
		direction: props.direction,
		disableOnInteraction: props.disableOnInteraction,
		duration: parseNumber(props.duration, 3000),
		effect: props.effect,
		loop: props.loop,
		maintenance: props.cmsLoaded && props.maintenance,
		options: options,
		pagination: props.pagination,
		paginationType: props.paginationType,
		play: props.play,
		speed: parseNumber(props.speed, 500),
		timing: props.timing
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': [props.class, props.styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(
			_dekuSlide2.default,
			_extends({}, settings, { styleClasses: props.styleClasses }),
			props.children
		)
	), props);
};

exports.default = { render: render };